import React from 'react';
import T from 'i18n-react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import AcceptingNumber from './AcceptingNumber';
import { getTermText } from '../utils';
import PlanTermContext from './context';
import Itinerary from './Itinerary';
import { displayGroupedDates } from '../../utils';

const Summary = ({ index }: { index: number }) => {
  const {
    planTerm: {
      startDate,
      endDate,
      number,
      holidays,
      isAccepting,
      isFutureOpen,
      acceptingNumber,
      remainingNumber,
    },
  } = React.useContext(PlanTermContext);

  const termText = getTermText({
    startDate,
    endDate,
    format: T.translate('moment.dayWithWeek'),
    formatWithoutYear: T.translate('moment.dayWithWeekWithoutYear'),
  });

  return (
    <Wrapper>
      <ItineraryWrapper>
        <Itinerary index={index} />
      </ItineraryWrapper>
      &nbsp;
      <div>
        <Typography component="span" variant="inherit" color="textPrimary">
          {termText}
        </Typography>
        &nbsp;&nbsp;
        <AcceptingNumber
          number={number}
          isAccepting={isAccepting}
          isFutureOpen={isFutureOpen}
        />
        {isAccepting && (
          <RemainingNumber>
            {T.translate('planPage.planTerms.remainingNumber', {
              count: remainingNumber,
            })}
          </RemainingNumber>
        )}
        <HolidayText>
          {T.translate('planPage.planTerms.freeHolidays', { count: holidays })}
        </HolidayText>
      </div>
    </Wrapper>
  );
};

export default Summary;

const Wrapper = styled.div`
  display: flex;
`;
const ItineraryWrapper = styled.div`
  width: 60px;
  min-width: 60px;
`;
const HolidayText = styled.p`
  margin: 0;
`;
const RemainingNumber = styled.span`
  border: 1px solid #ff6e2e;
  margin-left: 8px;
  color: #ff6e2e;
  font-size: 13px;
  font-weight: bold;
  border-radius: 30px;
  padding: 1px 15px;
`;
